export default "__VITE_ASSET__4449d154__"